module.exports = __webpack_public_path__ + "svg_80x80/uno.8de460.svg";